import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // This controller exists in order to support drop off look up / courier rates rates outlets
}
